import { render, staticRenderFns } from "./Depoimentos.vue?vue&type=template&id=0179055f&"
import script from "./Depoimentos.js?vue&type=script&lang=js&"
export * from "./Depoimentos.js?vue&type=script&lang=js&"
import style0 from "./Depoimentos.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QNoSsr});
